import { ServiceCode } from '../../../../common/enums/serviceCode';
import { GgzoEmblV1AdminDetails } from './GGZOembl/v1/GgzoEmblV1AdminDetails';
import { GgzoIntV1AdminDetails } from './GGZOint/v1/GgzoIntV1AdminDetails';
import { OsasoV1AdminDetails } from './OSASO/v1/OsasoV1AdminDetails';
import { OsasvoV1AdminDetails } from './OSASVO/v1/OsasvoV1AdminDetails';
import { TcohV2AdminDetails } from './TCOH/v2/TcohV2AdminDetails';

type AdminDetailsCustomControlsMap = {
    [serviceCode: string]: {
        [customControlVersion: number]: (props: any) => JSX.Element | null;
    };
};

const adminDetailsCustomControls: AdminDetailsCustomControlsMap = {
    [ServiceCode.TCOH]: {
        1: TcohV2AdminDetails,
        2: TcohV2AdminDetails,
    },
    [ServiceCode.GGZOembl]: {
        1: GgzoEmblV1AdminDetails,
    },
    [ServiceCode.GGZOint]: {
        1: GgzoIntV1AdminDetails,
    },
    [ServiceCode.OSASO]: {
        1: OsasoV1AdminDetails,
    },
    [ServiceCode.OSASVO]: {
        1: OsasvoV1AdminDetails,
    },
};

export function loadAdminDetailsCustomControl(version: number, serviceCode: ServiceCode) {
    return adminDetailsCustomControls[serviceCode]?.[version] ?? null;
}
